import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Layout } from './components/Layout';
import { GoogleAnalytics } from './components/GoogleAnalytics';
import { Home } from './pages/Home';
import { Services } from './pages/Services';
import { ServiceInfogerance } from './pages/ServiceInfogerance';
import { ServiceDepannage } from './pages/ServiceDepannage';
import { ServiceInfrastructure } from './pages/ServiceInfrastructure';
import { ServiceM365 } from './pages/ServiceM365';
import { ServiceSecurite } from './pages/ServiceSecurite';
import { ServiceConseil } from './pages/ServiceConseil';
import { Methode } from './pages/Methode';
import { Realisations } from './pages/Realisations';
import { About } from './pages/About';
import { Contact } from './pages/Contact';
import { MentionsLegales } from './pages/MentionsLegales';
import { Confidentialite } from './pages/Confidentialite';
import './App.css';

function ScrollToTop() {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <GoogleAnalytics />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/infogerance" element={<ServiceInfogerance />} />
          <Route path="/services/depannage" element={<ServiceDepannage />} />
          <Route path="/services/infrastructure" element={<ServiceInfrastructure />} />
          <Route path="/services/m365" element={<ServiceM365 />} />
          <Route path="/services/securite" element={<ServiceSecurite />} />
          <Route path="/services/conseil-dsi" element={<ServiceConseil />} />
          <Route path="/methode" element={<Methode />} />
          <Route path="/realisations" element={<Realisations />} />
          <Route path="/a-propos" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<MentionsLegales />} />
          <Route path="/confidentialite" element={<Confidentialite />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" />
    </BrowserRouter>
  );
}

export default App;
